import { useSelector } from 'react-redux';

import { hostedVideoSelectors } from '../../../../store/modules/hostedVideo';
import { getPreview } from '../../../../store/modules/hostedVideo/helpers';

const useManifestPreview = () => {
  const manifest = useSelector(hostedVideoSelectors.selectManifest);
  const manifestImage = getPreview((prev, { width }) => prev.width < width)(manifest, ['image']);

  return manifestImage?.path;
};

export default useManifestPreview;
